export default __webpack_public_path__ + "static/media/Desktop-SolarPanels.d7d441d7.jpeg";